import ErrorDemo from '@/components/ErrorBoundary/ErrorDemo';

const ErrorTestPage = () => {
  return <ErrorDemo />;
};

export default ErrorTestPage;